import styled from "@emotion/styled";

export const LinkKnownFile = styled.a`
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  max-width: fit-content;
  font-weight: 600;
`;
